export enum Pages {
    HOME = 'Home',
    WORK = 'Work',
    ABOUT = 'About',
    INSIGHTS = 'Insights',
    CONTACT = 'Contact',
}